import { message } from 'antd';
import { RecordInfoDrawer } from 'components/RecordInfoDrawer';
import { TableHeader } from 'components/TableHeader';
import {
  DELETE_ERROR,
  FETCH_ERROR,
  REQUEST_LOADING,
  SUCCESS_DELETE,
} from 'constants/alerts';
import { useDocumentTitle } from 'hooks/useDocumentTitle';
import { useDrawers } from 'hooks/useDrawers';
import { useHeaderChanger } from 'hooks/useHeaderChanger';
import { usePagination } from 'hooks/usePagination';
import React, { useEffect, useState, useCallback } from 'react';
import { RRPService } from 'services/RRPService';
import { formatDate } from 'utils';
import { priceRender } from 'utils/table';
import { RRPForm } from './RRPForm';
import { RRPTable } from './RRPTable';

function RRP() {
  useDocumentTitle('Регламентированные расчетные показатели');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const { setCount } = useHeaderChanger(
    'Регламентированные расчетные показатели'
  );
  const {
    state: { drawerVisible, formIsActive, activeRecord },
    openDrawer,
    closeDrawer,
    openCreateForm,
    openEditForm,
    closeForm,
  } = useDrawers();

  const { page, perPage, totalRows, setPagination, setTotalRows } =
    usePagination();

  const fetchItems = useCallback(async () => {
    if (!page || !perPage) {
      return;
    }

    setLoading(true);

    try {
      const { items = [], total } = await RRPService.getRRP(page, perPage);
      setTotalRows(total);
      setItems(items);
      setCount(total);
    } catch (err) {
      message.error(FETCH_ERROR);
    } finally {
      setLoading(false);
    }
  }, [page, perPage]);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  const handleDelete = async () => {
    const hide = message.loading(REQUEST_LOADING);

    try {
      const isDeleted = await RRPService.deleteRRP(activeRecord.id);

      if (isDeleted) {
        closeDrawer();
        fetchItems();
        message.success(SUCCESS_DELETE);
      }
    } catch (err) {
      message.error(DELETE_ERROR);
    } finally {
      hide();
    }
  };

  return (
    <>
      <TableHeader onCreate={openCreateForm} pageId="rrp" />

      <RecordInfoDrawer
        record={activeRecord}
        drawerTitle={activeRecord?.name}
        recordFields={[
          {
            label: 'Дата начала',
            key: 'begin_date',
            computedValue: formatDate(activeRecord?.begin_date),
          },
          {
            label: 'Дата окончание',
            key: 'end_date',
            computedValue: formatDate(activeRecord?.end_date),
          },
          {
            label: 'МРП',
            key: 'monthly_calculation_indicator',
            computedValue: `${priceRender(
              activeRecord?.monthly_calculation_indicator
            )} ₸`,
          },
          {
            label: 'МЗП',
            key: 'minimal_celery',
            computedValue: `${priceRender(activeRecord?.minimal_celery)} ₸`,
          },
          {
            label: 'Вычет по ИПН Инвалиды',
            key: 'pit_invalid',
            computedValue: `${priceRender(activeRecord?.pit_invalid)} ₸`,
          },
        ]}
        isVisible={drawerVisible}
        onClose={closeDrawer}
        onEdit={openEditForm}
        onDelete={handleDelete}
        deleteConfirmText="Вы точно хотите удалить эту запись ?"
        pageId="rrp"
      />

      <RRPTable
        items={items}
        loading={loading}
        current={page}
        pageSize={perPage}
        onRowClick={openDrawer}
        total={totalRows}
        onChange={setPagination}
      />

      <RRPForm
        isActive={formIsActive}
        initialValues={activeRecord}
        onSuccess={fetchItems}
        onClose={closeForm}
      />
    </>
  );
}

export { RRP };
